import { ApiResponse, standardizeAxiosApiError } from "../error";
import { GuestCart } from '../parent';
import { urql } from '../urql';

import { axios } from './axios';

export async function impersonate(id:string):Promise<ApiResponse> {
  try {
    const response = await axios.get(`/admin/users/impersonate`, {params: { impersonated_user_id: id }})

    urql.reset();
    GuestCart.clearToken();

    return {success: true, errors: []};
  }
  catch(e) {
    return e.response?.status === 404
      ? {success: false, errors: [{message: 'Incorrect email or password', path:['email']}]}
      : standardizeAxiosApiError(e)
  }
}
